<template>
    <l-modal :showing="showing" text="Edit user" icon="edit" color="bg-black" @close="close">
        <div class="w-full text-xs">
            <div class="w-full flex">
                <div class="w-full">
                    <b>Name *</b>
                    <br />
                    <l-input placeholder="Name" v-model="editObj.name" inputClass="text-2xs" @input="isValid" />
                </div>
            </div>
            <div class="w-full flex mb-4">
                <div class="w-full">
                    <b>Username/email *</b>
                    <br />
                    <l-input placeholder="Email / Username" v-model="editObj.username" inputClass="text-2xs" @input="isValid" />
                </div>
            </div>
            <div class="w-full flex mb-4">
                <div class="w-full">
                    <b>Set new password</b>
                    <br />
                    <l-input placeholder="Password" v-model="editObj.password" inputClass="text-2xs" @input="isValid" type="password" />
                </div>
            </div>
            <div class="w-64 mb-4">
                <b>Group</b>
                <br />
                <div class="w-56 float-left">
                    <l-select2 v-model="groupSelection" placeholder="Choose group(s)" :multiple="false" :options="groupSelectionList" :clearable="false" />
                </div>
                <div v-for="group in editObj.groupids" class="w-auto float-left">
                    <l-badge :showRemove="true" @close="removeGroup(group)">{{group.label}}</l-badge>
                </div>
            </div>
            <div class="w-full flex mb-4"></div>
            <div class="flex w-full justify-between">
                <l-button type="success" @click="onSave">Save user</l-button>
                <!--:disabled="!inputValidated"-->
                <l-button type="danger" @click="close">Cancel</l-button>
            </div>

        </div>
    </l-modal>
</template>

<script>
    import LModal from "@/components/LModal";
    import { LInput, LButton, LSelect2, LOption, LBadge } from "@/components/forms";
    import UserManagementService from "./usermanagement.service";

    export default {
        name: "LLEdit",
        props: ["showing", "selected", "groupSelectionList"],
        components: {
            LModal,
            LInput,
            LButton,
            LSelect2,
            LOption,
            LBadge
        },
        data() {
            return {
                inputValidated: false,
                selectedgroups: [],
                groupSelection: [],
            };
        },
        watch: {
            groupSelection: function (val) {
                if (val.length == 0) return;
                console.log(val);
                if (!this.editObj.groupids.includes(val)) this.editObj.groupids.push(val);
                this.groupSelection = [];
            }
        },
        computed: {
            editObj: function () {
                this.selected.password = '';
                console.log(this.selected);
                return Object.assign({}, this.selected);
            }
        },
        methods: {
            isValid() {
                this.inputValidated = !!this.editObj.title && !!this.editObj.zoneId;
            },
            close() {
                this.inputValidated = false;
                this.$emit("close");
            },
            removeGroup(val) {
                this.editObj.groupids.splice(this.selectedgroups.indexOf(val), 1);
            },
            onSave() {
                this.$emit("save", this.editObj);
                this.close();
            }
        }
    };
</script>